import React from 'react';
import { Stars } from './QuickTestimonials';
type Testimonial = {
  initials: string;
  quote: string;
  name: string;
  location: string;
};
const TESTIMONIALS: Testimonial[] = [{
  initials: 'EH',
  quote: 'I used to spend most of Sunday preparing the following week. Now I choose the right material, make a few personal adjustments, and everything is ready.',
  name: 'Emily H.',
  location: 'Manchester, UK'
}, {
  initials: 'SK',
  quote: 'The structure made an immediate difference. My transitions feel smoother, and every part of the class now has a clear purpose.',
  name: 'Sophie K.',
  location: 'Sydney, Australia'
}, {
  initials: 'PM',
  quote: 'I had dozens of saved posts and unfinished notes everywhere. This finally gave me one organized system I could actually use.',
  name: 'Priya M.',
  location: 'Auckland, New Zealand'
}, {
  initials: 'RT',
  quote: 'The modification guide helped me manage mixed-level groups with far more confidence. My students feel supported without interrupting the class flow.',
  name: 'Rachel T.',
  location: 'Vancouver, Canada'
}, {
  initials: 'LW',
  quote: 'As a newly qualified instructor, I felt overwhelmed by weekly preparation. Yoga Teaching Vault gave me a professional starting point from day one.',
  name: 'Laura W.',
  location: 'Birmingham, UK'
}, {
  initials: 'AN',
  quote: 'The Class Builder is incredibly practical. I can create a complete session quickly without making every class feel repetitive.',
  name: 'Amelia N.',
  location: 'Melbourne, Australia'
}, {
  initials: 'CB',
  quote: 'I teach six classes a week between a studio and two corporate clients, and preparation was quietly burning me out. Now I open the class library, pick the duration and level I need, adjust two or three poses for the group in front of me, and I am ready. My evenings genuinely came back to me, and the quality of my teaching went up rather than down.',
  name: 'Charlotte B.',
  location: 'Bristol, United Kingdom'
}, {
  initials: 'MD',
  quote: 'At 47 I retrained as a yoga teacher after twenty years in another career, and the hardest part was never the postures — it was sounding like a professional. The Cueing Masterbook changed that in a fortnight. I now have language for alignment, breath, and corrections that feels natural, and three students have told me my classes are the clearest they attend.',
  name: 'Megan D.',
  location: 'Wellington, New Zealand'
}, {
  initials: 'HL',
  quote: 'Most of my students are over sixty, so almost every class needs adapting. The modification and adaptation guide gave me prop options, poses to avoid, and safe alternatives I can apply in the moment without stopping the flow. My retention has improved noticeably because people feel looked after instead of left behind.',
  name: 'Hannah L.',
  location: 'Calgary, Canada'
}, {
  initials: 'JO',
  quote: 'I run online classes from home for students across three time zones, and I was constantly repeating the same familiar flows. The 52 weekly themes solved that completely — each week has an intention, focus poses, and a meditation idea, so my regulars always get something fresh. I have had more rebookings this quarter than in the whole of last year.',
  name: 'Jessica O.',
  location: 'Perth, Australia'
}, {
  initials: 'FR',
  quote: 'I hosted my first weekend workshop using the event toolkit and it sold out. The timelines, registration documents, and participant checklists meant nothing was left to chance, and the follow-up resources brought eight of those attendees into my regular weekly class. For twenty-seven dollars it paid for itself many times over.',
  name: 'Fiona R.',
  location: 'Christchurch, New Zealand'
}];
export function Testimonials() {
  return <section aria-labelledby="testimonials-title" className="w-full bg-white px-4 py-10 sm:px-6" data-id="element-227" data-mp="24zfbdo2q80j3">
      <div className="mx-auto max-w-6xl" data-id="element-228" data-mp="1lusn3n8eo9mz">
        <div className="text-center" data-id="element-229" data-mp="1gyby6qtdtr8u">
          <span className="font-head text-[11px] font-bold uppercase tracking-wider text-brand sm:text-xs" data-id="element-230" data-mp="1gzdd56diqxvu">
            Trusted by yoga instructors
          </span>
          <h2 id="testimonials-title" className="mt-2 font-head text-2xl font-extrabold uppercase text-charcoal sm:text-3xl" data-id="element-231" data-mp="1qvq3pvdrovmd">
            What instructors are saying
          </h2>
          <p className="mt-1 flex items-center justify-center gap-2 text-sm font-semibold text-charcoal" data-id="element-232" data-mp="1zn9yy7j74ncl">
            <Stars data-id="element-233" data-mp="2ek9dyggdnih3" />
            4.9/5 · 564+ Yoga Instructors
          </p>
        </div>

        <div className="mt-6 grid gap-3 md:grid-cols-2 lg:grid-cols-3" data-id="element-234" data-mp="29nixvt4komvo">
          {TESTIMONIALS.map(item => <figure key={item.name} className="flex flex-col rounded-2xl border border-brand/15 bg-ivory p-4" data-id="element-235" data-mp="k83019w3mnl3">
              <div className="flex items-center gap-2" data-id="element-236" data-mp="2qw21b7rhgebh">
                <span className="flex h-9 w-9 items-center justify-center rounded-full bg-brand font-head text-xs font-bold text-white" data-id="element-237" data-mp="2qwlgigpr0olt">
                  {item.initials}
                </span>
                <Stars data-id="element-238" data-mp="2h5h0res90zpx" />
              </div>
              <blockquote className="mt-2 text-sm italic leading-snug text-charcoal" data-id="element-239" data-mp="2m4tqq8ef2mwq">
                “{item.quote}”
              </blockquote>
              <figcaption className="mt-2 font-head text-xs font-semibold text-charcoal" data-id="element-240" data-mp="284itmnmikc34">
                {item.name}
                <span className="block font-body font-normal text-softgray" data-id="element-241" data-mp="2c88gn8njilm1">{item.location}</span>
              </figcaption>
            </figure>)}
        </div>
      </div>
    </section>;
}